<div [formGroup]="form">
    <mat-form-field *ngIf="documentType" appearance="fill" class="w-full">
        <mat-label>Tipo de Documento</mat-label>
        <mat-select formControlName="documentTypeId" placeholder="Seleccione un tipo de documento" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(documentTypeList, form.get('documentTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDocumentType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipo de documento..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterDocumentType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let documentType of filteredDocumentTypeList" [value]="documentType.code">
                {{ documentType.code }} - {{ documentType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="documentTypeFilter" appearance="fill" class="w-full">
        <mat-label>Tipo de Documento</mat-label>
        <mat-select formControlName="documentTypeId" placeholder="Seleccione un tipo de documento" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(documentTypeList, form.get('documentTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDocumentType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipo de documento..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterDocumentType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let documentType of filteredDocumentTypeList" [value]="documentType.code">
                {{ documentType.code }} - {{ documentType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="documentTypeLine" appearance="fill" class="w-full">
        <mat-label>Tipo de Documento de Línea</mat-label>
        <mat-select formControlName="documentTypeLineId" placeholder="Seleccione un tipo de documento de Línea" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(documentTypeLineList, form.get('documentTypeLineId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDocumentTypeLine" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipo de documento de línea..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterDocumentTypeLine($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let documentTypeLine of filteredDocumentTypeLineList" [value]="documentTypeLine.code">
                {{ documentTypeLine.code }} - {{ documentTypeLine.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="documentClass" appearance="fill" class="w-full">
        <mat-label>Clase de Documento</mat-label>
        <mat-select formControlName="documentClassId" placeholder="Seleccione una clase de documento" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(documentClassList, form.get('documentClassId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDocumentClass" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar una clase de documento..."
                    noEntriesFoundLabel="No se encontraron resultados" (ngModelChange)="filterDocumentClass($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let documentClass of filteredDocumentClassList" [value]="documentClass.code">
                {{ documentClass.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="documentClassWhitMongoId" appearance="fill" class="w-full">
        <mat-label>Clase de Documento</mat-label>
        <mat-select formControlName="documentClassId" placeholder="Seleccione una clase de documento" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(documentClassList, form.get('documentClassId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDocumentClass" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar una clase de documento..."
                    noEntriesFoundLabel="No se encontraron resultados" (ngModelChange)="filterDocumentClass($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let documentClass of filteredDocumentClassList" [value]="documentClass._id">
                {{ documentClass.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="typeEmissionPoint" appearance="fill" class="w-full">
        <mat-label>Tipo de Punto de Emisión</mat-label>
        <mat-select formControlName="typeEmissionPointId" placeholder="Seleccione un tipo de Punto de Emisión" multiple>
            <mat-option *ngFor="let typeEmissionPoint of typeEmissionPointList" [value]="typeEmissionPoint">
                {{ getListTypeLabel(typeEmissionPoint) }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="expenseReason" appearance="fill" class="w-full">
        <mat-label>Motivo de gasto</mat-label>
        <mat-select formControlName="expenseReasonId" placeholder="Seleccione un motivo de gasto" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(expenseReasonList, form.get('expenseReasonId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchExpenseEmision" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar motivo de gasto..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterExpenseReason($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let expense of expenseReasonFilteredtList" [value]="expense.id">
                {{ expense.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="pointEmission" appearance="fill" class="w-full">
        <mat-label>Punto de emisión</mat-label>
        <mat-select formControlName="pointEmissionId" placeholder="Seleccione un punto de emisión" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(emissionPointList, form.get('pointEmissionId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchPointEmission" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar un punto de emisión..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterPointEmission($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let point of listFilteremissionPointList" [value]="point.id">
                {{ point.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="requestType" appearance="fill" class="w-full">
        <mat-label>Tipo de Solicitud</mat-label>
        <mat-select formControlName="requestTypeId" placeholder="Seleccione tipo de solicitud" multiple
            (selectionChange)="onRequestTypeChange()">
            <mat-select-trigger>
                {{ getDisplayValueRequestType(form.get('requestTypeId')?.value) }}
            </mat-select-trigger>
            <mat-option [value]="true">
                <div class="text-sm leading-tight">
                    Extensión
                </div>
            </mat-option>
            <mat-option [value]="false">
                <div class="text-sm leading-tight">
                    Creación
                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>